import {
  useEffect,
  useState
} from 'react'
import {
  MapContainer,
  Marker,
  TileLayer,
  useMapEvent
} from 'react-leaflet'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Button,
  Box
} from '@chakra-ui/react'
import Leaflet from 'leaflet'
import { ImagesPng } from 'assets/images'
import {
  setIsLocationOpen,
  setUserPosition,
  usersSelectors
} from 'store'
import {
  MAP_ATTRIBUTION,
  MAP_URL,
  ZOOM_LEVEL,
  MAX_ZOOM_LEVEL,
  UNSUPPORTED_MAX_ZOOM_LEVEL
} from 'utils/constants'
import { iconMarkerImage } from 'utils/helpers'
import { COLORS } from 'utils/styles'

const northBound = Leaflet.latLng(85, Infinity)
const southBound = Leaflet.latLng(-85, -Infinity)
const fullBound = Leaflet.latLngBounds(northBound, southBound)

let html = `<img src="${ImagesPng.DefaultImage}" width="27px" height="27px" marginTop="5px" class="avatar-location-picker" alt="marker" />`
  + `<img src="${ImagesPng.PrimaryMarker}" width="27.5px" height="46px" class="marker-image-picker" alt="marker" />`

const NumberBreakdown = (param) => {
  let arr = (param + '').split('.')
  return arr[0] + '.' + arr[1].substring(0, 6)
}

export const MapModal = ({
  isStaticLocation,
  tempLocationData,
  full_name
}) => {
  const {
    isLocationOpen,
    randomPos,
    userPosition
  } = useSelector(usersSelectors)
  const [isPosSelected, setIsPosSelected] = useState(false)
  const dispatch = useDispatch()

  const LocationFinderDummy = () => {
    useMapEvent('click', (e) => {
      const lat = NumberBreakdown(e.latlng.lat)
      const lng = NumberBreakdown(e.latlng.wrap().lng)
      setIsPosSelected(true)
      dispatch(setUserPosition([lat, lng]))
      dispatch(setIsLocationOpen(true))
    })
    return null
  }

  useEffect(() => {
    if (!isLocationOpen) return () => {}

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        dispatch(setIsLocationOpen(false))
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isLocationOpen, dispatch])

  return (
    <>
      {isStaticLocation && (
        <Button
          fontWeight="400"
          width="100%"
          onClick={() => dispatch(setIsLocationOpen(true))}
          data-name="chooseStaticLocation"
          _focus={{ boxShadow: 'none' }}
          _focusVisible={{ boxShadow: 'none' }}
        >
          Choose Static Location
        </Button>
      )}

      {isLocationOpen && isStaticLocation && (
        <>
          <Box
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            bg="blackAlpha.600"
            zIndex={1412}
            onClick={() => dispatch(setIsLocationOpen(false))}
          />

          <Box
            position="fixed"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width="100vw"
            maxWidth="500px"
            height="100vh"
            maxHeight="500px"
            overflow="hidden"
            bg="white"
            borderRadius="md"
            boxShadow="lg"
            zIndex={1413}
            display="flex"
            flexDirection="column"
            onClick={(e) => e.stopPropagation()}
          >
            <Box
              px={6}
              py={4}
              fontSize="xl"
              fontWeight="bold"
            >
              Mark your position
            </Box>

            <Box
              as="button"
              name="close-location-modal"
              position="absolute"
              top={1}
              right={3}
              fontSize="md"
              p={2}
              onClick={() => dispatch(setIsLocationOpen(false))}
            >
              ✕
            </Box>

            <Box
              flex="1"
              px={6}
              overflowY="auto"
            >
              <MapContainer
                style={{ width: '100%', height: '100%' }}
                center={userPosition || tempLocationData}
                zoom={ZOOM_LEVEL}
                attributionControl={false}
                minZoom={1}
                worldCopyJump
                maxBounds={fullBound}
                maxBoundsViscosity={1.0}
                className="mapmodal"
              >
                <LocationFinderDummy />

                <TileLayer
                  attribution={MAP_ATTRIBUTION}
                  url={MAP_URL}
                  maxNativeZoom={MAX_ZOOM_LEVEL}
                  maxZoom={UNSUPPORTED_MAX_ZOOM_LEVEL}
                />

                {userPosition && (
                  <Marker
                    icon={iconMarkerImage(false, html)}
                    position={
                      isStaticLocation
                      && full_name === null
                      && isPosSelected === false
                      && (Number.isNaN(randomPos?.lat) === false
                      || Number.isNaN(randomPos?.lng) === false
                      ) ? randomPos : userPosition
                    }
                  />
                )}
              </MapContainer>
            </Box>

            <Box
              px={6}
              py={4}
              display="flex"
              justifyContent="flex-end"
            >
              <Box
                as="button"
                name="confirm-location"
                background={COLORS.gold}
                px={4}
                py={2}
                borderRadius="md"
                fontWeight="bold"
                onClick={() => dispatch(setIsLocationOpen(false))}
              >
                CONTINUE
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  )
}
